// renderCell.js
import React from 'react';
import HeaderSortCell from './HeaderSortCell';
import DataCell from './DataCell';

export const renderCell = (hoveredRowId,setHoveredRowId, handleSort, sortConfig) => {
  return ({ isHeaderCell, column, row }) => {
    if (isHeaderCell) {
      return <HeaderSortCell isHeaderCell={isHeaderCell} column={column} handleSort={handleSort} sortConfig={sortConfig} />;
    }

    return <DataCell row={row} column={column} setRowHovered={setHoveredRowId} hoveredRowId={hoveredRowId} />;
  };
};
